export const ProgressMeter = ({ decoded, total }) => {
  const pct = total ? Math.round((decoded / total) * 100) : 0;
  return (
    <section data-testid="vocabulary-progress" className="border border-cyan-400/20 bg-slate-950/60 p-4 sm:p-5">
      <div className="mb-3 flex items-baseline justify-between">
        <span className="lab-label">Memories recovered</span>
        <span data-testid="vocabulary-progress-percent" className="font-mono text-lg text-emerald-300 glow-emerald">{pct}%</span>
      </div>
      <div className="flex gap-1">
        {Array.from({ length: total }, (_, i) => (
          <span key={i} className={`h-4 flex-1 ${i < decoded ? "meter-on" : "bg-slate-800/80"}`} />
        ))}
      </div>
      <p className="mt-3 font-mono text-xs tracking-widest text-slate-500">
        {decoded >= total && total > 0 ? "ALL MEMORIES RECOVERED" : `${total - decoded} OBJECTS STILL TO OFFER`}
      </p>
    </section>
  );
};
